export const FETCH_AWARDS = {
  START: 'START_FETCH_AWARDS',
  COMPLETE: 'COMPLETE_FETCH_AWARDS',
  FAIL: 'FAIL_FETCH_AWARDS',
  CLEANUP: 'CLEANUP_FETCH_AWARDS',
}

export const ADD_AWARD = 'ADD_AWARD'
export const RENAME_AWARD = 'RENAME_AWARD'
export const RESET_AWARD_TREE = 'RESET_AWARD_TREE'

export const SET_DATA_FOR_RENAMING_AWARD = 'SET_DATA_FOR_RENAMING_AWARD'

export const SET_IS_CURATION_ENABLED_AWARD = {
  START: 'START_SET_IS_CURATION_ENABLED_AWARD',
  COMPLETE: 'COMPLETE_SET_IS_CURATION_ENABLED_AWARD',
  FAIL: 'FAIL_SET_IS_CURATION_ENABLED_AWARD',
}

export const DELETE_AWARD = {
  START: 'START_DELETE_AWARD',
  COMPLETE: 'COMPLETE_DELETE_AWARD',
  FAIL: 'FAIL_DELETE_AWARD',
}

export const MOVE_AWARDS = 'MOVE_AWARDS'

export const SAVE_AWARDS = {
  START: 'START_SAVE_AWARDS',
  COMPLETE: 'COMPLETE_SAVE_AWARDS',
  FAIL: 'FAIL_SAVE_AWARDS',
}

export const EXPAND_AWARD_MAIN_TREE_KEYS = 'EXPAND_AWARD_MAIN_TREE_KEYS'

export const EXPAND_AWARD_SUPPORTING_TREE_KEYS =
  'EXPAND_AWARD_SUPPORTING_TREE_KEYS'
